<template>
  <el-drawer
    :title="title"
    :visible.sync="showDrawer"
    :with-header="true"
    :before-close="handleClose"
    :size="drawerWidth"
    :withHeader="withHeader"
  >
    <div v-if="isLoading" class="min-h-screen flex items-center justify-center">
      <spinner />
    </div>
    <section v-else class="h-screen overflow-scroll py-4 -mt-3">
      <!-- header -->
      <div
        class="py-5 px-8 flex items-center justify-between transition-all duration-300 ease-linear border-b"
      >
        <h3 class="font-semibold test-sm">
          {{ title }}
        </h3>
        <close-icon @click.native="handleClose" size="h-5 w-5 cursor-pointer" />
      </div>
      <transition name="fade-in">
        <component
          :is="activeComponent"
          :currentBeneficiaryDetails="currentBeneficiaryDetails"
          class="px-4"
          @handleDeleteBeneficiary="handleDeleteBeneficiary"
        />
      </transition>
    </section>
  </el-drawer>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'Drawer',
  data () {
    return {
      breakpoints,
      isLoading: false,
      title: '',
      activeComponent: 'fiat-transfer',
      withHeader: false
    }
  },
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    currentBeneficiaryDetails: {
      type: Object,
      default: () => {},
      required: true
    },
    activeTab: {
      type: String,
      default: () => '',
      required: true
    }
  },
  components: {
    FiatTransfer: () =>
      import(
        '@/components/v2/settings/drawers/beneficiaryDetailsDrawer/FiatTransfer.vue'
      ),
    AssetTransfer: () =>
      import(
        '@/components/v2/settings/drawers/beneficiaryDetailsDrawer/AssetTransfer.vue'
      ),
    Spinner: () => import('@/components/v2/app/Spinner.vue'),
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue'),
    Transition: () =>
      import('@/components/v2/animation/transition/Transition.vue'),
    DeleteIcon: () => import('@/assets/icons/DeleteIcon.vue')
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  created () {
    if (this.activeTab === this.$transactionType.LOCAL_TRANSFER) {
      this.title = 'Beneficiary Details'
    } else if (this.activeTab === this.$transactionType.ASSET_TRANSFER) {
      this.title = 'Wallet Details'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDrawer')
    },
    handleDeleteBeneficiary () {
      this.$emit('handleDeleteBeneficiary')
    }
  },
  async mounted () {
    if (this.activeTab === this.$transactionType.LOCAL_TRANSFER) {
      this.activeComponent = 'fiat-transfer'
    } else {
      this.activeComponent = 'asset-transfer'
    }
  }
}
</script>
<style scoped>
>>> .el-drawer__header > :first-child {
  font-size: 0.9rem;
  color: var(--text-2);
  font-weight: 600;
}
>>> .el-drawer__header {
  color: var(--text-4);
  font-size: 1.2rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-left: 1.4rem;
  font-weight: 700;
  border-bottom: 1px solid var(--border-2);
}
>>> .el-drawer {
  background: var(--background-9) !important;
}
>>> .el-input--prefix .el-input__inner {
  border: 1px solid var(--border-1);
  border-radius: 8px;
  margin: 0, 6px;
  font-size: 0.9rem;
  color: var(--text-2);
  font-weight: 400;
  padding-left: 40px;
  background: var(--background-10);
}
.small-text {
  font-size: 0.6rem;
}
>>> li.number.active {
  background-color: var(--background) !important;
  border: 0.5px solid var(--color-primary) !important;
  box-sizing: border-box;
  border-radius: 100px;
  font-weight: 400;
  color: var(--color-primary) !important ;
}
>>> li.number {
  background-color: var(--background) !important;
  border: 0.5px solid var(--text-1) !important;
  box-sizing: border-box;
  border-radius: 100px !important;
  font-weight: 400;
}
</style>
